import { memo } from "react";

import { AddToCartButtonPlaceholder } from "@components/Button/AddToCartButtonPlaceholder.view";
import { AddonUpsellPlaceholder } from "@react/sections/ProductHero/AddonUpsell/AddonUpsellPlaceholder.view";
import { KlarnaPlaceholder } from "@react/sections/ProductHero/Klarna/KlarnaPlaceholder.view";
import { tw, type TTailwindString } from "classnames";

type Props = {
  addonUpsellProductsCount: number;
  productOptionCategoriesCount: number;
  showAddonUpsell: boolean;
};

const styles = {
  base: tw(
    "w-full",
    "flex",
    "flex-col",
    "gap-[29px]" as TTailwindString,
    "mg:gap-6"
  ),
  addonUpsell: tw("-mt-[29px]" as TTailwindString, "mg:-mt-6"),
};

const ProductFormPlaceholderBase = ({
  addonUpsellProductsCount,
  productOptionCategoriesCount,
  showAddonUpsell,
}: Props) => {
  return (
    <div className={styles.base}>
      {/* Product Option Categories */}
      {Array.from({ length: productOptionCategoriesCount }).map((_, index) => (
        <div
          className={tw("w-full", "flex", "flex-col", "gap-3.5")}
          key={index}
        >
          <div className={tw("flex", "items-baseline", "gap-2", "mg:mt-1")}>
            <div
              className={tw("h-4", "w-10", "rounded", "bg-placeholder")}
            ></div>
            <div
              className={tw("h-4", "w-24", "rounded", "bg-placeholder")}
            ></div>
          </div>
          <div className="flex flex-row flex-wrap gap-[10px]" key={index}>
            {Array.from({ length: 5 }).map((_, index) => (
              <div
                className="h-[38px] w-[38px] rounded-full border border-solid border-placeholder"
                key={index}
              >
                <div className="h-full w-full rounded-full border-3 border-solid border-transparent bg-placeholder bg-clip-padding"></div>
              </div>
            ))}
          </div>
        </div>
      ))}

      {showAddonUpsell && addonUpsellProductsCount > 0 && (
        // The shared section carries the same top spacing as the hydrated
        // AddonUpsell, so the column gap has to be cancelled here to match.
        <div className={styles.addonUpsell}>
          <AddonUpsellPlaceholder count={addonUpsellProductsCount} />
        </div>
      )}

      {/* Product Hero Add to Cart */}
      <div className={tw("mt-1", "mg:mt-4.5")}>
        <AddToCartButtonPlaceholder />
      </div>

      {/* Product Hero Klarna */}
      <div
        className={tw(
          "-mt-10",
          "mg:-mt-6",
          "mb-[27px]" as TTailwindString,
          "mg:mb-[21px]" as TTailwindString
        )}
      >
        <KlarnaPlaceholder />
      </div>
    </div>
  );
};

export const ProductFormPlaceholder = memo(ProductFormPlaceholderBase);
